exports.baseURL = "http://localhost:5000/";
exports.key = "W9rbjaqYjyCk9GyumQcr6NyMPWxGe7hD";
